package com.essntl.features.proposal.ui.proposalhistory

sealed interface ProposalOverviewNavigation {
    data class EditProposal(val proposalId: String) : ProposalOverviewNavigation
    data class EditInvoice(val proposalId: String, val invoiceId: String) : ProposalOverviewNavigation
    data class AddInvoice(val proposalId: String) : ProposalOverviewNavigation
}